import { useEffect } from "react";

/**
 * Sets document title, meta description, canonical, OG tags, and optional JSON-LD.
 * Cleans up JSON-LD on unmount.
 */
export default function useSeo({ title, description, canonical, image, type = "website", jsonLd } = {}) {
  useEffect(() => {
    const prev = document.title;
    if (title) document.title = title;

    const setMeta = (attr, value, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${value}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, value); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
      link.setAttribute("href", canonical);
    }

    let ldEl = null;
    if (jsonLd) {
      ldEl = document.createElement("script");
      ldEl.type = "application/ld+json";
      ldEl.dataset.medipats = "1";
      ldEl.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(ldEl);
    }

    return () => {
      document.title = prev;
      if (ldEl && ldEl.parentNode) ldEl.parentNode.removeChild(ldEl);
    };
  }, [title, description, canonical, image, type, JSON.stringify(jsonLd || null)]);
}
